import axios from 'axios';
import { getAccessToken } from '@/assets/js/auth';

// OpenStack Credentials
export const createOpenstackCredentials = async (regions) => {
  let teamId = localStorage.getItem('current_team_id');
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.post(`/api/openstack/users?team_id=${teamId}`, regions, settings);
}

export const updateCredential = async (credentialId, data) => {
  let teamId = localStorage.getItem('current_team_id');
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.patch(`/api/openstack/users?team_id=${teamId}&user_id=${credentialId}`, data, settings);
}

export const getOpenstackCredentials = async () => {
  let teamId = localStorage.getItem('current_team_id');
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };
  return axios.get(`/api/openstack/users?team_id=${teamId}`, settings);
}

export const deleteOpenstackCredentials = async (user) => {
  let teamId = localStorage.getItem('current_team_id');
  const url = `${user['@id']}&team_id=${teamId}`;
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.delete(url, settings);
}

// EC2/S3 Credentials
export const createS3Credentials = async (credentialId) => {
  let teamId = localStorage.getItem('current_team_id');
  let projectId = JSON.parse(localStorage.getItem('current_project')).id;
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };
  const url = `/api/openstack/users/ec2?team_id=${teamId}&espada_id=${credentialId}&project_id=${projectId}`;

  return axios.post(url, {}, settings);
}

export const getS3Credentials = async (credentialId) => {
  let teamId = localStorage.getItem('current_team_id');
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  return axios.get(`/api/openstack/users/ec2?team_id=${teamId}&espada_id=${credentialId}`, settings);
}

export const deleteS3Credentials = async (credentialId, ec2Access, region) => {
  let teamId = localStorage.getItem('current_team_id');
  const settings = {
    headers: {
      'Authorization': 'Bearer ' + getAccessToken()
    }
  };

  return axios.delete(`/api/openstack/users/ec2?team_id=${teamId}&espada_id=${credentialId}&ec2_access=${ec2Access}&region=${region}`, settings);
}

// OpenStack Projects
export const getProjectsByTeam = async (teamId) => {
  const settings = {
    headers: {
      'Authorization': 'Bearer ' + getAccessToken()
    }
  };

  return axios.get(`/api/openstack/projects?team_id=${teamId}`, settings);
}

export const createProject = async (data) => {
  let teamId = localStorage.getItem('current_team_id');
  const settings = {
    headers: {
      'Authorization': 'Bearer ' + getAccessToken()
    }
  };

  return axios.post(`/api/openstack/projects?team_id=${teamId}`, data, settings);
}

export const patchProject = async (data, projectId) => {
  let teamId = localStorage.getItem('current_team_id');
  const settings = {
    headers: {
      'Authorization': 'Bearer ' + getAccessToken()
    }
  };

  return axios.patch(`/api/openstack/projects?team_id=${teamId}&project_id=${projectId}`, data, settings);
}

export const getUnscopedToken = async (url) => {
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    },
  };
  return axios.get(`${url}/OS-FEDERATION/identity_providers/zitadel/protocols/openid/auth`, settings);
}

export const getScopedToken = async (unscopedToken, url, projectName, domainId) => {
  const settings = {
      withCredentials: true,
  };
  let data = {
      "auth": {
          "identity": {
              "methods": ["token"],
              "token": {
                  "id": unscopedToken,
              },
          },
          "scope": {
            "project": {
                "domain": {
                    "id": domainId
                },
                "name": projectName
            }
        }
      }
  }
  return axios.post(`${url}/auth/tokens`, data, settings);
}


export const migrateContainerToObjectStore = async (input, projectId) => {
  const data = {
    'source': {
      'secret': input.secret,
      'key': input.accessKey,
      'name': input.containerName,
      'vendor': 'Fuga Release 1 (S3)',
    }
  }
  let teamId = localStorage.getItem('current_team_id');
  const settings = {
    headers: {
      'Authorization': 'Bearer ' + getAccessToken()
    }
  };

  return axios.post(`/api/openstack/object-store/migrate?team_id=${teamId}&project_id=${projectId}`, data, settings);
}

export const getOpenstackDomainInfo = async (otherTeamId) => {
  let teamId = localStorage.getItem('current_team_id');
  const settings = {
    headers: {
      'Authorization': `Bearer ${getAccessToken()}`
    }
  };

  if (otherTeamId) {
      return axios.get(`/api/openstack/domain-info?team_id=${otherTeamId}`, settings);
  } else {
      return axios.get(`/api/openstack/domain-info?team_id=${teamId}`, settings);
  }
}
